import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { pregnancyKeys } from '../queries/keys';
import { pregnancyPaths } from '../queries/paths';

// Server-state de preñeces (api-reference/admin-pregnancies.md). El registro de
// una palpación (POST /:id/diagnostics) se hace en lote desde el workspace de Dx
// (loop con manejo parcial), así que acá solo va la lista.
export function usePregnanciesList(filters, opts = {}) {
    return useQuery({
        queryKey: pregnancyKeys.list(filters),
        queryFn:  ({ signal }) => api.get(pregnancyPaths.list(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
        ...opts,
    });
}

// Preñez ensamblada (0038, "cruce completo"): lineage del embrión (madre/padre),
// recipient_farm (finca), recipient y asocebu_ticket — todo en un DTO.
export function usePregnancy(id, opts = {}) {
    return useQuery({
        queryKey: pregnancyKeys.detail(id),
        queryFn:  ({ signal }) => api.get(pregnancyPaths.detail(id), { signal }).then(r => r.data),
        enabled:  !!id,
        ...opts,
    });
}
